import { toValue, useHead, useSeoMeta } from '#imports';
import { useAbsoluteUrl } from '~/composables/useAbsoluteUrl';
import { siteName } from '~/constants';

interface ApplyShortsSeoMetaParams {
	title: MaybeRefOrGetter<string>;
	description: MaybeRefOrGetter<string>;
	keywords: MaybeRefOrGetter<string>;
	ogImage?: MaybeRefOrGetter<string | undefined>;
	ogImageWidth?: MaybeRefOrGetter<number | undefined>;
	ogImageHeight?: MaybeRefOrGetter<number | undefined>;
	ogImageType?: MaybeRefOrGetter<'image/jpeg' | undefined>;
}

const DEFAULT_OG_IMAGE = '/images/social/openGraph/og_home.webp';

export function applyShortsSeoMeta(params: ApplyShortsSeoMetaParams) {
	const { toAbsoluteUrl } = useAbsoluteUrl();
	const ogImage = () =>
		toAbsoluteUrl(toValue(params.ogImage) || DEFAULT_OG_IMAGE);

	useSeoMeta({
		title: params.title,
		description: params.description,
		keywords: params.keywords,
		ogTitle: params.title,
		ogDescription: params.description,
		ogImage,
		ogImageWidth: () => toValue(params.ogImageWidth),
		ogImageHeight: () => toValue(params.ogImageHeight),
		ogImageType: () => toValue(params.ogImageType),
		ogSiteName: siteName,
		twitterTitle: params.title,
		twitterDescription: params.description,
		twitterImage: ogImage,
		twitterCard: 'summary_large_image'
	});

	useHead({
		meta: [
			{
				name: 'site_name',
				content: siteName
			}
		]
	});
}
